import { translate } from '@repo/phrase';
import { Paragraph } from '@repo/ui/typography';

import { DialogModal } from '@/components/dialog-modal';

interface Props {
    visible: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isPending: boolean;
}

export const AttachmentDeleteModal = ({ visible, onClose, onConfirm, isPending }: Props) => {
    return (
        <DialogModal
            visible={visible}
            onClose={onClose}
            title={translate('attachments_delete_confirm_title')}
            primaryButtonProps={{
                text: translate('dialog_modal_footer_yes'),
                onClick: onConfirm,
                loading: isPending,
            }}
            secondaryButtonProps={{
                text: translate('dialog_modal_footer_no'),
                onClick: onClose,
                disabled: isPending,
            }}
        >
            <Paragraph>{translate('attachments_delete_confirm_body')}</Paragraph>
        </DialogModal>
    );
};
